import { useRouter } from 'next/router'
import { OrderType } from '__generated__/types'

// OrderType paths
// /m/[merchantLocationId]?ot=p -> Pickup
// /m/[merchantLocationId]?ot=del -> Delivery
// /m/[merchantLocationId]/t/[tableId]?ot=d -> DineIn
// /m/[merchantLocationId]/t/[tableId]?ot=r -> RoomService
// /m/[merchantLocationId]/t/[tableId]?ot=res -> Resort

type OrderTypeQueryParam = 'p' | 'del' | 'd' | 'r' | 'res'

const OTToOrderTypeMap: Record<OrderTypeQueryParam, OrderType> = {
  del: OrderType.Delivery,
  d: OrderType.DineIn,
  p: OrderType.Pickup,
  res: OrderType.Resort,
  r: OrderType.RoomService
}

// Determines the order type from a combination of the url path and query parameters.
const useOrderType = (): {
  ot: OrderTypeQueryParam | undefined
  orderType: OrderType | undefined
} => {
  const router = useRouter()
  const tableId = router.query.tableId as string | undefined
  const ot = router.query.ot as OrderTypeQueryParam | undefined

  if (ot && OTToOrderTypeMap[ot]) {
    return { ot, orderType: OTToOrderTypeMap[ot] }
  }

  if (tableId) {
    // If path is /m/[merchantLocationId]/t/[tableId] with no ot query param,
    // default to a dine-in order.
    return { ot: 'd', orderType: OrderType.DineIn }
  }

  if (Object.keys(router.query).length === 0) {
    // The router has not been hydrated on the client yet.
    return { ot: undefined, orderType: undefined }
  }

  // If the path is /m/[merchantLocationId] with no ot query param, default to a
  // pickup order.
  return { ot: 'p', orderType: OrderType.Pickup }
}

export default useOrderType
